import { isBrowser } from "../common/helpers/env";
import axios from "axios";
import { showNotification } from "./store/notification/actions";
import detector from "detector";
import { pianoHost } from "./paths";

import StartAudioContext from "startaudiocontext";

const isUndef = (val: any) => {
    return typeof val === "undefined";
};

const getAudioContext = () => {
    if (!isBrowser) return;
    //polyfill for AudioContext and OfflineAudioContext
    if (isUndef(window.AudioContext)) {
        window.AudioContext = (window as any).webkitAudioContext;
    }
    if (!isUndef(AudioContext)) {
        return new AudioContext();
    }
}
class Player {
    isIOS = isBrowser ? detector.os.name === "ios" : false;
    context: AudioContext = getAudioContext()!;
    slap?: {
        createNode: (volume: any) => AudioBufferSourceNode;
        buffer: AudioBuffer;
    } = undefined;
    forte?: GainNode;
    mezzo?: GainNode
    constructor() {
        if (!isBrowser) return;
        this.setUpContext();
        if (this.isIOS) {
            StartAudioContext(this.context);
        }
        window.addEventListener("focus", () => {
            setTimeout(() => {
                this.resumeContext();
            }, 500);
        });
    }
    totalTry = 0;
    loadSlap = async () => {
        if (!isBrowser) return;
        try {
            const res = await axios({
                method: "get",
                url: pianoHost + "sound/slap2.mp3",
                responseType: "arraybuffer",
            });
            if (res.data) {
                const result = await this.decodeAudio(res.data);
                if (!result) return false;
                const { createNode, buffer } = result;
                this.slap = { createNode, buffer };
                return true;
            } else {
                this.totalTry++;
                if (this.totalTry < 5) {
                    setTimeout(this.loadSlap, 1000);
                }
                return false;
            }
        } catch (e) {
            this.totalTry++;
            if (this.totalTry < 5) {
                setTimeout(this.loadSlap, 1000);
            }
            return false;
        }
    };

    setUpContext = () => {
        if (!isBrowser) return;
        if (!isUndef(AudioContext)) {
            this.forte = this.context.createGain();
            this.forte.gain.value = 2;
            this.forte.connect(this.context.destination);
            this.mezzo = this.context.createGain();
            this.mezzo.gain.value = 1.6;
            this.mezzo.connect(this.context.destination);
            window.addEventListener("click", this.resumeContext);
        } else {
            console.error("Web Audio is not supported in this browser");
        }
    };
    resumeContext = () => {
        if (!isBrowser) return;
        if (this.context) {
            window.removeEventListener("click", this.resumeContext);
            this.context.resume();
        }
    };

    decodeAudio = async (data: ArrayBuffer): Promise<{ buffer: AudioBuffer, createNode: (volume: "forte" | "mezzo" | undefined) => AudioBufferSourceNode } | undefined> => {
        if (!isBrowser) return;
        try {
            const buffer: AudioBuffer = await new Promise((resolve, reject) => {
                this.context.decodeAudioData(
                    data,
                    b => {
                        resolve(b);
                    },
                    e => {
                        window.store.dispatch(showNotification("Error while loading audio file.", "warning"));
                        reject();
                    }
                );
            });
            if (!buffer) return
            let createNode = (volume: "forte" | "mezzo" | undefined) => {
                let node = this.context.createBufferSource();
                node.buffer = buffer;
                if (volume === "forte") {
                    node.connect(this.forte!);
                } else if (volume === "mezzo") {
                    node.connect(this.mezzo!);
                } else {
                    node.connect(this.context.destination);
                }
                return node;
            };
            return { createNode, buffer };
        } catch (error) {
            return;
        }
    };
}

export default new Player();
